export enum TreeType {
  CATEGORY = 'category',
  GROUP = 'group',
  FIELD = 'field',
}
